import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Button } from '@pella/sash-framework';

// Styles
import styles from './index.module.scss';

const TimeslotCell = ({ onClick, timeslot, selected, disabled }) => (
	<Button
		className={`${styles.rtaCalendar_Time_Button} ${selected ? styles.rtaCalendar_Time_Selected : styles.rtaCalendar_Time_Available}`}
		color='secondary'
		onClick={() => {
			onClick(timeslot.arrayPosition);
		}}
		type='button'
		disabled={disabled}
	>
		{`${timeslot.time} ${timeslot.period}`}
	</Button>
);

TimeslotCell.propTypes = {
	timeslot: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
};

export default TimeslotCell;
